import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { faCircleCheck } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';

export const EligibleBadge = ({ isEligible }: { isEligible: boolean }) => {
  return (
    <div
      className={clsx(
        'flex items-center gap-1 font-base text-base-s',
        isEligible ? 'font-semibold text-fuchsia500' : 'font-medium text-base500',
      )}
    >
      {isEligible ? (
        <>
          <FontAwesomeIcon icon={faCircleCheck} fontSize={14} />
          Eligible
        </>
      ) : (
        'Not Eligible'
      )}
    </div>
  );
};
